// extracted by mini-css-extract-plugin
module.exports = {"image":"why-should-you-get_image__ioLLX","section_title":"why-should-you-get_section_title__awaM3","features_list":"why-should-you-get_features_list__u__49"};